export const DOWNLOAD_APP_LINK_NPS =
  'https://new-download.onelink.me/IqrF/782fz293';

export const DOWNLOAD_APP_LINK_LINE =
  'https://new-download.onelink.me/IqrF/depwsbjs';
